import { useEffect, useState } from "react";
import { db } from "../../matabase";
import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import TopStory from "../../pages/home/TopStory";

const TopStories = () => {
  const [posts, setPosts] = useState([]);
  const [err, setErr] = useState(null);
  const [load, setLoad] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoad(true);
      setErr(null);

      try {
        const q = query(
          collection(db, "posts"),
          where("top", "==", "yes"),
          orderBy("date", "desc"),
          limit(4),
        );

        const res = await getDocs(q);

        const data = res.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setPosts(data);
        console.log(data);
      } catch (error) {
        console.error(error);
        setErr("Something went wrong");
      }

      setLoad(false);
    };

    fetchData();
  }, []);

  return (
    <div>
      {load && <p>Loading...</p>}
      {err && <p>{err}</p>}
      <TopStory posts={posts} />
    </div>
  );
};

export default TopStories;
